/**
 * Returns a user-friendly string for the action type.
 * @param {string} historyType - The history type symbol ("+", "~", "-").
 * @return {string} The action label.
 */
export const getActionLabel = historyType => {
  switch (historyType) {
    case "+":
      return "created";
    case "~":
      return "updated";
    case "-":
      return "deleted";
    default:
      return "modified";
  }
};

/**
 * Maps specific fields to more human-readable labels.
 * @param {string} fieldName - The raw field name from the API (e.g., "ordered_qty").
 * @return {string} The formatted field label.
 */
export const getFieldLabel = fieldName => {
  if (!fieldName) return "Record";
  // Replace underscores with spaces and capitalize words
  return fieldName
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
